export default "__VITE_ASSET__ab1fdee2__"